import { checkPromoCode, checkCouponCode } from '@/api/coupon'
import { useCartStore } from '@/store/cart'

const tryPromoCodes = async (coupon: string): Promise<Coupon|undefined> => {
    try {
        const couponResponse: Coupon = await checkPromoCode(coupon)
        return {
            ...couponResponse,
            type: 'promo',
        }
    } catch (e) {
        try {
            const couponResponse: Coupon = await checkCouponCode(coupon)
            return {
                ...couponResponse,
                valid: true,
                code: coupon,
                type: 'membership',
            } as Coupon
        } catch (e) {
            throw new Error(`Invalid coupon code for this product`)
        }
    }
}


/**
 * Checks and applies a promo code to the current checkout
 * Directly modifies the checkout store and returns a success boolean
 * @param string coupon
 * @returns boolean
 */
const usePromoCode = () => {
    const cart = useCartStore()

    const applyPromoCode = async (couponCode: string): Promise<boolean> => {
        const coupon: Coupon|undefined = await tryPromoCodes(couponCode)
        if (!coupon) {
            return false
        }

        cart.$patch({
            couponPromo: coupon,
        })

        return true
    }

    return {
        applyPromoCode,
        checkPromoCode,
    }
}

export default usePromoCode
